<template>
  <div id="page">
    <div class="cardFaceGroup">
      <div>
        <input id="cardFront" type="radio" v-model="showCardFront" name="cardFaceRd" value="0"></input>
        <label for="cardFront">正面</label>
        /
        <input id="cardBack" type="radio" v-model="showCardFront" name="cardFaceRd" value="1"></input>
        <label for="cardBack">背面</label>
      </div>
    </div>

    <div class="rootDiv" align="center">
      <div id="absoluteDiv" v-bind:class="isHorizontal ? 'absoluteDiv' : 'absoluteDiv vertical'">
        <img ref="frontCover" id="cardFrontCover" v-bind:class="isHorizontal ? 'cardFrontCover' : 'cardFrontCover frontCoverV'"
          v-bind:src="isHorizontal? frontCoverH:frontCoverV"></img>
        <img ref="frontImg" id="cardFrontImg" v-bind:class="isHorizontal ? 'cardFront' : 'cardFront frontV'" v-bind:src="cardFace" />
        <img ref="backCover" id="cardBackCover" v-bind:class="isHorizontal ? 'cardBackCover1' : 'cardBackCover1 backCoverV1'"
          v-bind:src="isHorizontal? backCoverH:backCoverV"></img>
        <img ref="backImg" id="cardBackImg" v-bind:class="isHorizontal ? 'cardBack' : 'cardBack backV'"></img>
      </div>
    </div>

    <div>
      <b-container>
        <b-row class="rowItem">
          <b-col cols="12">
            <h6>请挑选您的专属卡底</h6>
          </b-col>
          <b-col>
            <div class="parent">
              <div class="RadioStyle item" v-for="(item, index) in kadis" :key="index">
                <input v-model="kadiColor" type="radio" :id="item.nameCN" name="kadiColorRd" :value="item.id">
                <!-- <input v-model="kadiColor" type="radio" :id="item.nameCN" name="kadiColorRd" :value="item.pantoneCode"> -->
                <label :for="item.nameCN" :style="{'background-color':item.hexCode}"></label>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="rowItem" v-show="true">
          <b-col cols="12">
            <h6>请挑选您的专属工艺</h6>
          </b-col>
          <b-col>
            <div class="chk_div imgDiv">
              <div v-for="(item, index) in kgys" :key="index">
                <input v-model="kagongyi" type="radio" :value="item.id" :id="item.technologyName" name="kgyRd">
                <label :for="item.technologyName" :style="{'background-image': 'url(' + item.technologyUrl + ')'}"></label>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="rowItemNotice">
          <b-col>
            您须同意《卡面上传图片须知》、《卡面定制服务确认书》
          </b-col>
        </b-row>

        <b-row class="rowItem">
          <b-col cols="1">
            <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" value="accepted" unchecked-value="not_accepted" />
          </b-col>
          <b-col>
            我已阅读并同意遵守<font color="red" @click="showUploadNotice()">《卡面上传图片须知》</font>、<font color="red" @click="showConfirmNotice()">《卡面定制服务确认书》</font>
          </b-col>
        </b-row>

        <b-row class="rowItem">
          <b-col cols="10" class="mx-auto">
            <b-button block :disabled="disabled" variant="danger" @click="submitAction()">上传图片</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定">
      <p class="my-4">{{errorMsg}}</p>
    </b-modal>

    <b-modal ref="model_confirm_notice" ok-only scrollable title="卡面定制服务确认书" ok-title="确定">
      <div>
        <p>1. 本人同意接受四川天府银行合作伙伴恒宝股份有限公司提供的卡面定制服务并支付相关服务费用。</p>
        <p>2. 本人保证对本人上传的图片拥有知识产权，图片上的人物肖像（如有）为他人肖像的，本人承诺已取得其书面合法授权，
          授权本人和贵行在定制卡面业务中使用其肖像。 如图片上的人物肖像为未成年人，本人承诺为该未成年人的监护人，授权贵行在定制卡面业务中使用其肖像。</p>
        <p>3. 本人知晓并同意定制卡面上传的图片需经过审核通过方可作为卡面使用，本服务提供方有权自主决定审核结果。但审核并不代表对图片肖像权或著作权的认可或承诺。本人知晓并同意，若上传的图片未通过审核，四川天府银行有权不予核发。</p>
        <p>4. 本人知晓，如因电脑显示、上传等原因产生色差导致卡面效果产生偏差的，以收到卡片实物效果为准。</p>
        <p>5. 本人承诺因本人提供的图片侵犯违法违规、第三人合法权利、违反《卡面上传图片须知》中的规则或本承诺等情形而发生的争议，本人自行解决，因此给贵行造成的损失，本人承担损失赔偿责任。</p>
        <p>6. 本人知悉并完全理解上述内容，愿意遵守上述约定。如违反上述约定的，本人自愿接受对本人采取的包括但不限于：删除，屏蔽网路信息等必要措施。</p>
      </div>
    </b-modal>


    <b-modal ref="model_upload_notice" ok-only scrollable title="卡面上传图片须知" ok-title="确定">
      <div>
        <p>
          上传图片的专利权、版权、人物肖像权（如有，且用户仅能上传本人或未成年子女照片）、
          商标权、著作权等知识产权均由素材提供方负责，并确保该素材不存在任何侵犯第三人合法权利的因素及遵守以下规则：
        </p>
        <p>1. 不与国家法律法规相违背。</p>
        <p>2. 不含煽动或鼓吹反政府,推翻政府的文字或图像。</p>
        <p>3. 不含有与政治主题相关的文字和图像。</p>
        <p>4. 不含有涉及性、血腥、暴力、裸露、不雅主题及其他可被认定为“社会不能接受”相关主题的文字或图像。</p>
        <p>5. 不含有涉及种族、宗教、民族、性别歧视主题的文字或图像。</p>
        <p>6. 不含有可能引起银行卡诈骗的文字和图像。</p>
        <p>7. 不含有违反社会主义道德和公序良俗的文字和图像。</p>
        <p>8. 不侵害他人肖像权、姓名权、名誉权、隐私权等权利以及他人的知识产权。</p>
        <p>9. 不含有侮辱、诽谤或带有歧视性的文字或图像。</p>
        <p>10. 不含有会引起任何人不适的内容。</p>
        <p>11. 不含有任何名牌产品或服务的图片，以及包括这些品牌的缩写、简写或近似的文字或图像。</p>
        <p>12. 不含有广告促销及招揽性质的文字或图像。</p>
        <p>13. 不含有容易引发误解的语言或数字，包括电话号码或与服务相关的任何文字或图像。</p>
        <p>14. 不含有可能在商户受理卡片过程中产生任何误解和混乱的文字或图像。</p>
        <p>15.其他不适合作为卡面的文字或图像。</p>
      </div>
    </b-modal>

    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">上传中</p>
      </div>
    </div>

    <div v-show="showToast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <p class="weui-toast__content">{{toastMsg}}</p>
      </div>
    </div>
  </div>
</template>

<script scoped>
  import axios from 'axios'
  var config = require('../../common/config.js')
  import wx from 'weixin-js-sdk'
  export default {
    name: 'UploadCardface_schtnf',
    data() {
      return {
        cardFace: '',
        selectParam: null,
        cardOri: '',
        bankSerialNumber: '',
        kadiColor: '',
        kadiColorT: '',
        kagongyi: 2,
        showCardFront: 0,
        isHorizontal: true,
        orderNo: '',
        bankCode: '',
        errorMsg: '',
        coverImages: [],
        frontCoverH: config.config_schtnf.frontCoverH,
        frontCoverV: config.config_schtnf.frontCoverV,
        backCoverH: config.config_schtnf.backCoverH,
        backCoverV: config.config_schtnf.backCoverV,

        kadis: [],
        kgys: [],
        cardTheme: 2,
        status: 'not_accepted',
        disabled: true,
        loading: false,
        showToast: false,
        toastMsg: '',
        type: '', //参数的值 0- 第一次上传  1-重新上传  2-补卡。
        audit: false, //下单时，是否进行AI审核, true 审核, false 不审核

      }
    },
    watch: {
      kadiColor: function(newval, oldval) {
        console.log("当前卡底色：" + newval, "之前的卡底色：" + oldval);
        var img = this.$refs.backImg;
        for (let i = 0; i < this.kadis.length; i++) {
          let item = this.kadis[i];
          if (item.id == newval) {
            img.style.backgroundColor = item.hexCode;
            this.kadiColorT = item.pantoneCode;
            break;
          }
        }
      },
      showCardFront: function(newval, oldval) {
        console.log("当前显示卡面的值：" + newval, "之前显示卡面的值：" + oldval);
        var frontCover = this.$refs.frontCover;
        var frontImg = this.$refs.frontImg;
        var backCover = this.$refs.backCover;
        var backImg = this.$refs.backImg;
        if (newval == 0) {
          console.log("显示")
          frontCover.style.display = "";
          frontImg.style.display = "";
          backCover.style.display = "";
          backImg.style.display = "";
        } else {
          console.log("隐藏")
          frontCover.style.display = "none";
          frontImg.style.display = "none";
          backCover.style.display = "";
          backImg.style.display = "";
        }
      },
      kagongyi: function(newval, oldval) {
        console.log("卡工艺：" + newval, "之前显示卡工艺的值：" + oldval);
      },
      status: function(newval, oldval) {
        console.log("newval：" + newval, "oldval：" + oldval);
        if (newval == 'accepted') {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    },
    computed: {
      coverImagesWrapper: function() {
        // h_back: "bank_layout/0051/back/0051_0_1.png"
        // h_front: "bank_layout/0051/front/0051_0_1.png"
        // model: 1
        // v_back: "bank_layout/0051/back/0051_1_1.png"
        // v_front: "bank_layout/0051/front/0051_1_1.png"
        var temp = this.coverImages;
        var array = [];
        if (temp.length > 0) {
          array = new Array(temp.length);
          for (var i = 0; i < temp.length; i++) {
            var obj = temp[i];
            obj.h_front =  obj.h_front;
            obj.h_back = obj.h_back;
            obj.v_front =  obj.v_front;
            obj.v_back =  obj.v_back;
            // obj.h_front = config.baseCardfaceUrl + obj.h_front;
            // obj.h_back = config.baseCardfaceUrl + obj.h_back;
            // obj.v_front = config.baseCardfaceUrl + obj.v_front;
            // obj.v_back = config.baseCardfaceUrl + obj.v_back;
            array[i] = obj;
          }
        }
        return array;
      }
    },
    methods: {
      showToastMsg: function(msg) {
        this.toastMsg = msg;
        let that = this;
        that.showToast = true;
        setTimeout(function() {
          that.showToast = false;
        }, 2000);
      },
      showLoading: function() {
        this.loading = true;
      },
      hideLoading: function() {
        this.loading = false;
      },
      showUploadNotice: function() {
        this.$refs['model_upload_notice'].show();
      },
      showConfirmNotice: function() {
        this.$refs['model_confirm_notice'].show();
      },
      handleOk: function(bvModalEvt) {

      },
      showErrorMsg: function() {
        this.$refs['model_error'].show();
      },
      hideErrorMsg: function() {
        this.$refs['model_error'].hide();
      },
      submitAction: function() {
        if (this.type == 1) {
          this.modifyOrder()
        } else if( this.type == 0) {
          this.submitOrder();
        } else {
          this.errorMsg = "未知type类型:" + this.type;
          this.showErrorMsg();
        }
      },
      submitOrder: function() {
        if (this.kadiColor.length == 0) {
          this.showToastMsg('请选择您的卡底色')
          return;
        }

        if (this.kagongyi.length == 0) {
          this.showToastMsg('请选择您的卡工艺')
          return;
        }

        var that = this;
        that.showLoading();
        console.log(this.cardFace)

        var myObj = {
          bankSerialNumber: this.bankSerialNumber,
          cardType: 1,
          cardTechnology: this.kagongyi,
          cardTypography: this.cardOri,
          backgroupColor: this.kadiColorT,
          cardSubject: this.cardTheme,
          bankCode: this.bankCode,
          facadeImage: "",
          facademd5: "",
          audit: this.audit
        };

        console.log(myObj);

        this.imgToDataUrl(this.cardFace, (dataUrl) => {
          myObj.facadeImage = dataUrl;
          var facademd5 = this.$md5(dataUrl);
          myObj.facademd5 = facademd5;

          // String bankSerialNumber //针对每张卡片的唯一号
          // int cardType; //1-借记卡 / 2-信用卡
          // int cardTechnology; //工艺
          // int cardTypography //横版/竖版
          // int backgroupColor //底片颜色
          // int cardSubject //动物/人物/风景...
          // String bankCode //银行编号（用于区分银行）

          axios({
            method: 'post',
            url: config.config_schtnf.submitOrder,
            data: myObj,
            onUploadProgress: function(progressEvent) {
              var percent = '0';
              var percentage = '0%';

              if (progressEvent.lengthComputable) {
                percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                percentage = percent + '%';
                console.log(percentage);
              }
            }
          }).then(function(response) {
            that.hideLoading();
            console.log(response);
            var result = response.data;
            /* {
              code: 0
              deadline: "20200523093922"
              message: "交易成功"
              notify_url: "http://196.98.98.101/pos/order/payOrder"
              orderDateTime: "2020-05-22 09:39:22"
              orderNo: "01248790113566597120"
              price: 1
              projectName: "DIY"
              thumbnailFileUrl: null
            } */
            if (result.code == 0) {
              that.errorMsg = "上传图片成功"
              that.showErrorMsg();

              if (that.type == 0) {
                wx.miniProgram.navigateTo({
                  url: '/pages/applyDebitCard/upIdCard/upIdCard'
                })
              }
            } else {
              /* {
                code: 1004
                deadline: null
                message: "银行唯一号不允许重复使用"
                notify_url: null
                orderDateTime: null
                orderNo: null
                price: null
                projectName: null
                thumbnailFileUrl: null
              } */
              that.errorMsg = result.message;
              that.showErrorMsg();
            }

          }).catch(function(error) {
            that.hideLoading();
            console.log(error);
          })
        })

      },
      modifyOrder: function() {

        if (this.kadiColor.length == 0) {
          this.showToastMsg('请选择您的卡底色')
          return;
        }


        var that = this;
        that.showLoading();
        var myObj = {
          orderNo: this.selectParam.orderNo,
          backgroupColor: this.kadiColorT,
          cardTypography: this.cardOri,
          cardTechnology: this.kagongyi,
          facadeImage: "",
          facademd5: "",
          audit: this.audit
        }

        this.imgToDataUrl(this.cardFace, (dataUrl) => {
          myObj.facadeImage = dataUrl;
          var facademd5 = this.$md5(dataUrl);
          myObj.facademd5 = facademd5;

          axios({
            method: 'post',
            url: config.config_schtnf.modify,
            data: myObj,
            onUploadProgress: function(progressEvent) {
              var percent = '0';
              var percentage = '0%';

              if (progressEvent.lengthComputable) {
                percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                percentage = percent + '%';
                console.log(percentage);
              }
            }
          }).then(function(response) {
            console.log(response);
            that.hideLoading();
            var result = response.data;
            if (result.code == 0) {
              that.errorMsg = "修改图片成功"
              that.showErrorMsg();
              if (that.type == 1) {
                wx.miniProgram.navigateTo({
                  url: '/pages/applyDebitCard/submitSuccess/submitSuccess'
                })
              }
            } else {
              that.errorMsg = result.message;
              that.showErrorMsg();
            }

          }).catch(function(error) {
            console.log(error);
            that.hideLoading()
          })
        })
      },
      imgToDataUrl: function(url, callback) {
        var Img = new Image(),
          dataURL = '';
        Img.src = url;
        Img.onload = function() { //要先确保图片完整获取到，这是个异步事件
          var canvas = document.createElement("canvas"), //创建canvas元素
            width = Img.width, //确保canvas的尺寸和图片一样
            height = Img.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中
          dataURL = canvas.toDataURL('image/png'); //转换图片为dataURL
          callback(dataURL);
        };
      },
      dataURLtoBlob: function(dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime
        });
      },
      queryCardTheme: function() {
        let that = this;
        axios.get(config.config_schtnf.queryBankDict, {
          params: {
            bankCode: config.config_schtnf.bankCode
          }
        }).then(function(response) {
          console.log(response)
          let data = response.data;
          that.kadis = data.backgroudColorList;
          that.kgys = data.cardTechnologyList;
        }).catch(function(error) {
          console.log(error)
        });
      },
      getLayoutImageByBankCode: function() {
        let that = this;
        axios.get(config.config_schtnf.getLayoutImageByBankCode, {
            params: {
              bankCode: config.config_schtnf.bankCode
            }
          }).then(function(response) {
            console.log(response);
            let data = response.data;
            that.coverImages = data;
            console.log(that.coverImagesWrapper);
            var wrapper = that.coverImagesWrapper
            for (var i = 0; i < wrapper.length; i++) {
              var item = wrapper[i];
              //默认卡面
              if (item.model == 1) {
                that.frontCoverH = item.h_front;
                that.backCoverH = item.h_back;
                that.frontCoverV = item.v_front;
                that.backCoverV = item.v_back;
              }
              console.log("frontCoverH:" + that.frontCoverH);
              console.log("backCoverH:" + that.backCoverH);
              console.log("frontCoverV:" + that.frontCoverV);
              console.log("backCoverV:" + that.backCoverV);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    mounted: function() {

      this.queryCardTheme();
      this.getLayoutImageByBankCode();
      this.bankSerialNumber = this.$route.params.bankSerialNumber;
      this.bankCode = this.$route.params.bankCode;
      console.log('bankSerialNumber:' + this.bankSerialNumber);
      console.log('bankCode:' + this.bankCode);

      var destImg = this.$route.params.targetImg;
      this.cardFace = destImg
      console.log('destImg:' + destImg)

      var selectParam = this.$route.params.selectParam;
      console.log('selectParam:' + selectParam)
      if (selectParam !== undefined) {
        this.selectParam = JSON.parse(selectParam)
      }

      /* let themeParam = this.$route.params.cardTheme;
      console.log('themeParam:' + themeParam)
      if (themeParam !== undefined) {
        this.cardTheme = JSON.parse(themeParam)
        this.kadis = this.cardTheme.backgroudColorList;
        this.kgys = this.cardTheme.cardTechnologyList;
      } */

      this.cardOri = this.$route.params.cardOri;
      console.log('cardOri:' + this.cardOri);
      if (this.cardOri == 0) {
        //横版
        this.isHorizontal = true;
      } else if (this.cardOri == 1) {
        //竖版
        this.isHorizontal = false;
      }

      if (1 == this.kgys.length) {
        this.kagongyi = this.kgys[0].id;
      }

      this.showCardFront = 0;

      this.type = this.$route.params.type;
      console.log('type:' + this.type);
    }
  }
</script>

<style scoped>
  .lefttext {
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
  }

  .actionArea {
    margin-top: 32px;
    margin-bottom: 24px;
  }

  .cardFront {
    position: absolute;
    z-index: 25;
    left: 10px;
    top: 10px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .frontV {
    position: absolute;
    z-index: 25;
    width: 124px;
    height: 193px;
    left: 10px;
    top: 10px;
  }

  .cardFrontCover {
    position: absolute;
    z-index: 30;
    left: 10px;
    top: 10px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .frontCoverV {
    position: absolute;
    z-index: 30;
    width: 124px;
    height: 193px;
    left: 10px;
    top: 10px;
  }

  .cardBack {
    position: absolute;
    z-index: 15;
    left: 20px;
    top: 20px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .backV {
    position: absolute;
    z-index: 15;
    width: 124px;
    height: 193px;
    left: 20px;
    top: 20px;
  }

  .cardBackCover1 {
    position: absolute;
    z-index: 20;
    left: 20px;
    top: 20px;
    width: 253px;
    height: 160px;
    border-radius: 4.5%;
  }

  .backCoverV1 {
    position: absolute;
    z-index: 20;
    width: 124px;
    height: 193px;
    left: 20px;
    top: 20px;
  }

  .absoluteDiv {
    position: relative;
    width: 300px;
    height: 190px;
  }

  .vertical {
    position: relative;
    width: 140px;
    height: 220px;
  }

  .rootDiv {
    position: relative;
    background-color: #f1f2f3;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
  }

  .cardFaceGroup {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: flex-end;
    height: 64px;
  }

  .cardFaceGroup input {
    display: none;
  }

  .cardFaceGroup label {
    color: gray;
    line-height: 28px;
    min-width: 20vw;
    min-height: 28px;
    text-align: center;
    border-radius: 4px;
    margin: 8px;
  }

  .cardFaceGroup input:checked+label {
    background-size: 21px 21px;
    font-weight: bold;
    color: black;
    margin: 8px;
  }

  .kadiItem {
    display: flex;
    width: 25%;
    height: 3rem;
  }

  .RadioStyle input {
    display: none
  }

  .RadioStyle label {
    border: 1px solid #00a4ff;
    color: #fff;
    line-height: 28px;
    min-width: 100%;
    min-height: 28px;
    text-align: center;
    float: left;
    font-size: 10px;
    border-radius: 4px;
  }

  .RadioStyle input:checked+label {
    border: 4px solid #00a4ff;
    background-size: 21px 21px;
    color: #fff;
  }

  .RadioStyle input:disabled+label {
    opacity: 0.7;
  }

  .parent {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 25%;
    height: 3rem;
    margin-left: 0.5rem;
    border-radius: 4px;
  }

  .imgDiv {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .chk_div input {
    display: none;
  }

  .chk_div label {
    background-size: 64px 48px;
    width: 64px;
    height: 40px;
    display: block;
    padding-left: 35px;
    padding-top: 5px;
    margin: 8px;
  }

  .chk_div input[type=radio]:checked+label {
    border: 4px solid #00a4ff;
    border-radius: 4px;
  }

  .rowItem {
    margin-top: 16px;
  }

  .rowItemNotice {
    margin-top: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: #f1f2f3;
  }
</style>



// WEBPACK FOOTER //
// src/components/sichuantianfubank/UploadCardface_schtnf.vue